export default __webpack_public_path__ + "static/media/icon-arrow.e14420af.svg";